import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";

export function Login() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const m = params.get("m");
    const p = params.get("p");
    const exp = params.get("exp");
    const t = params.get("t");
    if (!m || !p || !exp || !t) {
      setErr("This link is incomplete. Send `ADMIN` to the bot to get a fresh one.");
      return;
    }
    api("/api/login", {
      method: "POST",
      body: JSON.stringify({ m, p, exp: Number(exp), t })
    })
      .then(() => nav("/dashboard", { replace: true }))
      .catch((e: Error) => setErr(e.message));
  }, [params, nav]);

  return (
    <div className="max-w-md mx-auto mt-20 p-6 text-center">
      <h1 className="text-xl font-semibold">Signing you in…</h1>
      {err ? (
        <div className="mt-4 text-red-600 text-sm">
          <p className="font-medium">Couldn't sign in.</p>
          <p className="mt-1">{err}</p>
          <p className="mt-3 text-neutral-600">
            Send <code className="bg-neutral-100 px-1.5 py-0.5 rounded">ADMIN</code> via WhatsApp to get a new link.
          </p>
        </div>
      ) : (
        <p className="mt-2 text-neutral-500">…</p>
      )}
    </div>
  );
}
